<ng-container *ngIf="showBloque">
  <div class="header" [style]="{ '--color-fondo-menu': configBloque.color_fondo, '--color-fondo-newsletter': configBloqueNewsletter?.color_fondo_newsletter, '--color-fondo-links': configBloqueNewsletter?.color_fondo_links, '--color-texto-dos': configBloqueNewsletter?.color_texto_dos }">
    <div class="sub-header">
      <ng-container *ngIf="showBuscador">
        <div #buscadorRef class="buscador">
          <form class="search_form" [formGroup]="searchForm" (ngSubmit)="clickBusqueda()">
            <button type="submit" #buttonRef class="btn-search" aria-label="Boton buscar">
              <app-icon-search></app-icon-search>
            </button>
            <input #inputRef formControlName="search" [ngClass]="mostrarBuscador ? 'showInput' : 'closeInput'" type="text" class="input-search" placeholder="Buscar..." />
          </form>
        </div>
      </ng-container>
      <ng-container *ngIf="show24h">
        <a [routerLink]="'noticias-24-horas'" class="radio" (click)="playPause()" aria-label="Boton noticias 24 horas">
          <ng-container *ngIf="icono24h">
            <span class="animate-flicker">
              <app-icon-red-circle></app-icon-red-circle>
            </span>
            <div class="radioIcon">
              <app-icon-24-hours></app-icon-24-hours>
            </div>
          </ng-container>
        </a>
      </ng-container>
      <span class="spacer"></span>
      <ng-container *ngIf="showRadio">
        <div class="radio" (click)="playPause()">
          <ng-container *ngIf="iconoRadio">
            <div class="radioIcon">
              <app-icon-24-hours></app-icon-24-hours>
            </div>
          </ng-container>
          <audio #audioRadio [src]="urlRadio"></audio>
          <span class="animate-flicker">
            <app-icon-red-circle></app-icon-red-circle>
          </span>
          <span class="radioIcon" style="cursor: pointer; margin-right: 12px">
            <ng-container *ngIf="!boolAudio">
              <app-icon-play></app-icon-play>
            </ng-container>
            <ng-container *ngIf="boolAudio">
              <app-icon-pause></app-icon-pause>
            </ng-container>
          </span>
        </div>
      </ng-container>
      <ng-container *ngIf="showReels && !hideOrientation">
        <div role="radiogroup" aria-label="Opciones de visualización de noticias" class="toggle-group">
          <button [ngClass]="{ selected: currentMode === 'clasico' }" (click)="onReelsClick('clasico')" aria-label="Cambiar a vista clásica">
            <app-icon-view-news [color]="currentMode === 'clasico' ? '#393876' : '#000'"></app-icon-view-news>
          </button>

          <button [ngClass]="{ selected: currentMode === 'vertical' }" (click)="onReelsClick('vertical')" aria-label="Cambiar a vista vertical">
            <app-icon-reels [color]="currentMode === 'vertical' ? '#393876' : '#000'"></app-icon-reels>
          </button>

          <button [ngClass]="{ selected: currentMode === 'horizontal' }" (click)="onReelsClick('horizontal')" aria-label="Cambiar a vista horizontal">
            <app-icon-carousel [color]="currentMode === 'horizontal' ? '#393876' : '#000'"></app-icon-carousel>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="showLogin">
        <ng-container *ngIf="!userLogin; else closeSesion">
          <button class="btn-login" aria-label="Boton iniciar sesion" (click)="this.showLoginModal = !this.showLoginModal">
            <app-icon-user></app-icon-user>
          </button>
        </ng-container>

        <ng-template #closeSesion>
          <button class="btn-login" aria-label="Boton cerrar sesion" (click)="logout()">
            <app-icon-log-out></app-icon-log-out>
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showLoginModal">
  <app-modal-login (closeModal)="this.showLoginModal = !this.showLoginModal"></app-modal-login>
</ng-container>
